import { Typography } from '@mui/material';

function Title({ title }) {
    return <Typography variant="h4">{title}</Typography>;
}

export default Title;
